import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { loadProductDetail } from "../services/productDetailService";
import {
  mapProductDtoToDetail,
  type ProductDetail,
} from "../mappers/productDetailMapper";

export const useProductDetails = (
  productId: string,
): UseQueryResult<ProductDetail | null> => {
  return useQuery({
    queryKey: ["productDetails", productId],
    queryFn: async () => {
      const result = await loadProductDetail(productId);

      if (result.error) {
        throw new Error(result.error.message);
      }

      return mapProductDtoToDetail(result.data);
    },
    enabled: !!productId,
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchOnMount: true
  });
};
